import { generateTestId } from "@client-shared";

export const setCarrierNavTestId = (identifier: string): string => generateTestId("CarrierNav", identifier);

export const setCarrierNavItemTestId = (accountNumber: string): string => setCarrierNavTestId(`item-${accountNumber}`);
